import awsmobile from './aws-exports';

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/,
    ),
);

const isDevelopment = window.location.hostname === 'dev.enterpret.ai';
const isStaging = window.location.hostname === 'enterpret-showcase.vercel.app';
const isPreProd = window.location.hostname === 'pre-prod.enterpret.ai';

const [
  localRedirectSignIn,
  stagingRedirectSignIn,
  developmentRedirectSignIn,
  productionRedirectSignIn,
  preProdRedirectSignIn,
] = awsmobile.oauth.redirectSignIn.split(',');

const [
  localRedirectSignOut,
  stagingRedirectSignOut,
  developmentRedirectSignOut,
  productionRedirectSignOut,
  preProdRedirectSignOut,
] = awsmobile.oauth.redirectSignOut.split(',');

export const getRedirectURI = () => {
  if (isLocalhost) {
    return {
      redirectSignIn: localRedirectSignIn,
      redirectSignOut: localRedirectSignOut,
    };
  }
  if (isStaging) {
    return {
      redirectSignIn: stagingRedirectSignIn,
      redirectSignOut: stagingRedirectSignOut,
    };
  }
  if (isDevelopment) {
    return {
      redirectSignIn: developmentRedirectSignIn,
      redirectSignOut: developmentRedirectSignOut,
    };
  }
  if (isPreProd) {
    return {
      redirectSignIn: preProdRedirectSignIn,
      redirectSignOut: preProdRedirectSignOut,
    };
  }
  return {
    redirectSignIn: productionRedirectSignIn,
    redirectSignOut: productionRedirectSignOut,
  };
};

const updatedAwsConfig = {
  ...awsmobile,
  oauth: {
    ...awsmobile.oauth,
    ...getRedirectURI(),
  },
};

export default updatedAwsConfig;
